// test1004
(1004 && 0);
